import { VideosPreviewType } from "../../../../Infrastructure/Services/VideosPreviewService";
import React from "react";
import {
    ActionButtonsContainer,
    ActionIconBox,
    PlayVideoIconButton,
    VideoPreviewBox,
} from "./PreviewCardSwiper.styles";
import { PlaySolidIcon } from "../../Icon/PlaySolidIcon";
import { PostDetailsActionType } from "../../Modals/PostDetailsModal/PostDetailsModalStore";
import { PostDetailsPageActions } from "../../Modals/PostDetailsModal/PostDetailsModal";
import { CommentIcon } from "../../Icon/CommentIcon";
import { ThumbsUpLightIcon } from "@icons/ThumbsUpLightIcon";

export function PreviewSlider({
    onPostCardClick,
    video,
}: {
    onPostCardClick: (postId: string, action?: PostDetailsActionType) => void;
    video: VideosPreviewType;
}) {
    return (
        <VideoPreviewBox
            onClick={() => {
                onPostCardClick(video.postId.toString(), {
                    desiredAction: PostDetailsPageActions.AUTO_PLAY_VIDEO,
                });
            }}
        >
            <img src={video.thumbnailUrl} />
            <PlayVideoIconButton>
                <PlaySolidIcon />
            </PlayVideoIconButton>
            <ActionButtonsContainer>
                <ActionIconBox>
                    <ThumbsUpLightIcon />
                    {video.reactionCount > 0 &&
                        video.reactionCount.toLocaleString("de-DE")}
                </ActionIconBox>
                <ActionIconBox>
                    <CommentIcon />
                    {video.commentCount > 0 &&
                        video.commentCount.toLocaleString("de-DE")}
                </ActionIconBox>
            </ActionButtonsContainer>
        </VideoPreviewBox>
    );
}
